import { render, staticRenderFns } from "./HowItBegan.vue?vue&type=template&id=12e9143c&lang=pug&"
import script from "./HowItBegan.vue?vue&type=script&lang=ts&"
export * from "./HowItBegan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HowItBegan.vue"
export default component.exports